module.exports = __webpack_public_path__ + "img/jeonpo_thumbnail.a8b211f6.jpg";